import React from 'react';
import { useEffect, useState } from 'react';

import {
  Box,
  Grid,
  Hidden,
  Link,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    copyright: {
      color: '#8189A9',
      fontSize: '14px',
      marginRight: '10px',
    },
    link: {
      color: '#A84308',
      fontSize: '14px',
    },
  })
);

const Footer = ({ dashboard }) => {
  const classes = useStyle();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  const [hasVerticalScroll, setHasVerticalScroll] = useState(false);

  useEffect(() => {
    function handleLoad() {
      const body = document.body;
      const hasVerticalScroll = body.scrollHeight > window.innerHeight;

      setHasVerticalScroll(hasVerticalScroll);
    }

    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <>
      <footer
        style={{
          position: 'relative',
          bottom: 0,
          width: '100%',
        }}
      >
        <Hidden xsDown implementation="css">
          <Box
            style={{
              borderTop: '1px solid #E7E7E7',
              padding: '16px 0px',
              margin: '24px 64px 0px 64px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              {/* <Typography className={classes.copyright}>
                © Copyright Galicia Seguros Argentina 2023
              </Typography> */}
            </Box>
            <Box>
              <Link
                className={classes.link}
                href={process.env.REACT_APP_TYC}
                color="primary"
                target="_blank"
              >
                Términos y condiciones
              </Link>
            </Box>
          </Box>
        </Hidden>

        <Hidden smUp implementation="css">
          <Box
            style={{
              borderTop: '1px solid #E7E7E7',
              padding: '16px 0px',
              margin: '24px 30px 0px 30px',
            }}
          >
            <Box mb={2}>
              <Link
                className={classes.link}
                href={process.env.REACT_APP_TYC}
                color="primary"
                target="_blank"
              >
                Términos y condiciones
              </Link>
            </Box>
            <Box>
              {/* <Typography className={classes.copyright}>
                © Copyright Galicia Seguros Argentina 2023
              </Typography> */}
            </Box>
          </Box>
        </Hidden>
      </footer>
    </>
  );
};
export default Footer;
